import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  id: "kt_app_content",
  class: "app-content flex-column-fluid py-0"
}
const _hoisted_2 = { class: "d-flex justify-content-end" }
const _hoisted_3 = {
  key: 0,
  class: "bi bi-arrows-angle-contract fs-4"
}
const _hoisted_4 = {
  key: 1,
  class: "bi bi-arrows-fullscreen fs-4"
}
const _hoisted_5 = { class: "svg-icon svg-icon-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { id: "custom-target-swal2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "kt_app_content_container",
      ref: "fullScreenContent",
      class: _normalizeClass(["app-default app-content app-container", {
        'container-fluid': _ctx.contentWidthFluid,
        'container-xxl': !_ctx.contentWidthFluid,
        'pt-6 pb-6 scroll-y': _ctx.isFullscreen,
      }])
    }, [
      _createVNode(_component_router_view),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exibirContentFullScreen && _ctx.exibirContentFullScreen(...args))),
          "data-bs-toggle": "tooltip",
          "data-bs-placement": "top",
          title: "Full Screen",
          class: _normalizeClass(["btn-full-screen btn btn-sm btn-icon btn-primary btn-active-primary", [
            _ctx.isScrolltopActive ? `scrolltop-true` : `scrolltop-false`,
            _ctx.isFullscreen ? `full-screen-true` : `full-screen-false`,
          ]])
        }, [
          (_ctx.isFullscreen)
            ? (_openBlock(), _createElementBlock("i", _hoisted_3))
            : (_openBlock(), _createElementBlock("i", _hoisted_4))
        ], 2),
        (_ctx.isScrolltopActive && _ctx.isFullscreen)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["btn-scroll-top btn btn-sm btn-icon btn-primary btn-active-primary", [_ctx.isScrolltopActive ? `scrolltop-true` : `scrolltop-false`]]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollTop && _ctx.scrollTop(...args)))
            }, [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr066.svg" })
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _hoisted_6
    ], 2)
  ]))
}